import { css } from "@vitality-ds/system";

// eslint-disable-next-line import/prefer-default-export
export var BaseButtonWrapper = css({
  // @Todo When we have the primitives package, this should become an internal variant
  button: {
    height: 22,
    lineHeight: 1
  }
});